module.exports = __webpack_public_path__ + "img/ic-arrow-up.19f8714e.svg";